import type { FaireBrandEntity } from "../../entity_types/brand";

export const sweet_wink: FaireBrandEntity = {
  token: "sweet-wink",
  type: "brand",
  name: "Sweet Wink",
  location: "Dallas, TX",
  minimumOrderDollars: 150,
  rating: 4.9,
  isTopShop: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "parity-fix",
  },
};
